angular.module('usersService', ['ui.router','constants'])
.factory('usersService', function($http, $q, $state, myConfig) {

  var service = {};

	var _baseUrl = myConfig.apiUrl + 'main/users'; //'http://127.0.0.1:8000/v1/main/users';

  // get users - not admins, with rings roles
	service.fetchUsers = function(additionalUrl){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = myConfig.apiUrl + 'rings/vw_rings_users'
    if (typeof additionalUrl !== 'undefined' && additionalUrl !== null){
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
			withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
		}).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;

  }

  // get users - from view, which is slower, but allows for quering
  service.fetchUsersRaw = function(additionalUrl){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = myConfig.apiUrl + 'rings/vw_rings_users2'
    if (typeof additionalUrl !== 'undefined' && additionalUrl !== null){
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;

  }

  // get users - not admins, with rings roles
  service.fetchRingers = function(additionalUrl){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = myConfig.apiUrl + 'rings/vw_ringers'
    if (typeof additionalUrl !== 'undefined' && additionalUrl !== null){
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;

  }

  // get users - all users
  service.fetchMainUsers = function(){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'GET',
      url: _baseUrl, //'http://127.0.0.1:8000/v1/rings/vw_rings_users',
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;

  }

  // get new lincence number
  service.getLicenceNumber = function(){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'GET',
      url: myConfig.apiUrl + 'rings/licencenumber', //'http://127.0.0.1:8000/v1/rings/vw_rings_users',
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;

  }

  // construct of put request to change the user role
  /*
  example: 
    input: constructJSON({uid:1, isRinger:true, isActive:false},'isRinger','RingerRole')
    returns: {uid:1;RingerRole:1}
  */
  service.constructJSON = function(user, param1, param2){
    var body = {};
    // user id
    body['UID'] = user.UID;
    // which value
    var value = (user[param1] ? 1 : 0);
    body[param2] = value;
    
    return body;
  }

  // construct of put request to change the user role
  service.constructJSONFromUserInfo = function(user){
    
    var body = {};
    // user id
    body['UID'] = user.UID;
    body['Name'] = user.Name;
    body['Surname'] = user.Surname;
    body['Title'] = user.rings.Title;
    body['Email'] = user.Email;
    body['Telephone'] = user.Telephone;
    body['Address'] = user.Address;
    body['City'] = user.City;
    body['Postcode'] = user.Postcode;
    body['Country'] = user.Country;
    body['Birthday'] = yyyymmdd(user.rings.Birthday);
    body['LicenceNumber'] = user.rings.LicenceNumber;
    body['ID_Okres'] = user.rings.ID_Okres;
    body['DateUpd'] = 'CURRENT_TIMESTAMP'     // inject update date and timer
    return body;
  }

  // update record in Users table
  service.updateUser = function(body) {
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'PUT',
      url: _baseUrl + '?id=UID',
      data: body,
			withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
		}).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update record in ProjRingsUsers
  service.updateRingsUser = function(body) {
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'PUT',
      url: myConfig.apiUrl + 'rings/projringsusers?id=UID', //'http://127.0.0.1:8000/v1/rings/projringsusers?id=UID',
      data: body,
			withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
		}).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  changes the password of user
  */
  service.changePassword = function(body) {
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'POST',
      url: myConfig.apiUrl + 'changepassword', //'http://127.0.0.1:8000/v1/changepassword',
      data: body,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
		}).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update record in Users table
  service.fetchAccountMovements = function(additionalUrl) {
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = myConfig.apiUrl + 'rings/accountmovements';
    if (typeof additionalUrl !== 'undefined' && additionalUrl !== null){
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update/insert record in account movements
  service.updateAccountMovement = function(body) {
    var _method = (typeof body.ID === 'undefined' ? 'POST' : 'PUT')
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: _method,
      url: myConfig.apiUrl + 'rings/accountmovements',
      data: body,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // delete record in account movements
  service.deleteAccountMovement = function(additionalUrl) {
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: 'DELETE',
      url: myConfig.apiUrl + 'rings/accountmovements' + additionalUrl,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

   /*
  * get list of user settings
  */
  service.fetchUsersettings = function(additionalUrl){
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = myConfig.apiUrl + 'rings/usersettings';
    if (typeof additionalUrl !== 'undefined'){
      url += additionalUrl
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
         
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update/insert user settings
  service.updateUsersettings = function(body) {
    var _method = ((typeof body.ID === 'undefined' || body.ID == null) ? 'POST' : 'PUT')
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    $http({
      method: _method,
      url: myConfig.apiUrl + 'rings/usersettings',
      data: body,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // send mail to users
  service.sendEmail = function(data){
    var tableName = 'main/send_mail_generic';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = myConfig.apiUrl + tableName;
    $http({
      method: 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
